import {
    CONFIRMED_GET_CONTENT,
    CONFIRMED_CREATE_CONTENT,
    CONFIRMED_EDIT_CONTENT,
    CONFIRMED_DELETE_CONTENT,
    CONFIRMED_SEND_CONTENT,
    FAILED_SEND_CONTENT,
  } from "./ContentBankType"
  import {
    getContentList,
    addContent,
    editContent,
    deleteContent,
    sendContent,
    formatContentList,
  } from "../../services/ContentBankService"
  import { handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService"
  
  // Fetch all content
  // export function getContentListAction(pagination = true, pageid = 0,search_by = "", search_keyword = "") {
  //   return async (dispatch) => {
  //     try {
  //       const response = await getContentList(pagination, pageid,search_by,search_keyword)
  //       if (response?.status === 200 && response?.data?.status === "success") {
  //         const contentList = formatContentList(response.data.data)
  //         dispatch({ type: CONFIRMED_GET_CONTENT, payload: contentList })
  //         return { success: true, data: contentList }
  //       } else {
  //         throw new Error(response?.data?.message || "Failed to fetch content")
  //       }
  //     } catch (error) {
  //       console.error("Get content list error:", error)
  //       dispatch({ type: "FAILED_GET_CONTENT", payload: error.message })
  //       showErrorAlert(error.message || "Failed to fetch content")
  //       throw error
  //     }
  //   }
  // }
  export function getContentListAction(pagination = true, pageid = 0, search_by = "", search_keyword = "", sort_by = "", sort_order ="" ) {
    return async (dispatch) => {
      try {
        const response = await getContentList(pagination, pageid, search_by, search_keyword,sort_by,sort_order);
        if (response?.status === 200 && response?.data?.status === "success") {
          const contentList = formatContentList(response.data.data);
          dispatch({
            type: CONFIRMED_GET_CONTENT,
            payload: {
              contentList,
              num_rows: response.data.num_rows || 0
            }
          });
          return { success: true, data: contentList };
        } else {
          throw new Error(response?.data?.message || "Failed to fetch content");
        }
      } catch (error) {
        console.error("Get content list error:", error);
        dispatch({ type: "FAILED_GET_CONTENT", payload: error.message });
        showErrorAlert(error.message || "Failed to fetch content");
        throw error;
      }
    };
  }
  
  
  export function createContentAction(contentData) {
    return async (dispatch) => {
      try {
        const response = await addContent(contentData)
        if (response?.status === 200 && response?.data?.status === "success") {
          handleSuccess("Success!", "Content added successfully!")
          dispatch({ type: CONFIRMED_CREATE_CONTENT, payload: response.data.data })
          return { success: true, data: response.data.data }
        } else {
          throw new Error(response?.data?.message || "Failed to add content")
        }
      } catch (error) {
        console.error("Add content error:", error)
        showErrorAlert(error.message || "Failed to add content")
        throw error
      }
    }
  }
  
  // Edit existing content
  export function editContentAction(contentData) {
    return async (dispatch) => {
      try {
        const response = await editContent(contentData)
        console.log("Edit content response:", response.data.data)

        if (response?.status === 200 && response?.data?.status === "success") {
          handleSuccess("Success!", "Content updated successfully!")
          dispatch({ type: CONFIRMED_EDIT_CONTENT, payload: response.data.data })
          return { success: true, data: response.data.data }
        } else {
          throw new Error(response?.data?.message || "Failed to update content")
        }
      } catch (error) {
        console.error("Edit content error:", error)
        showErrorAlert(error.message || "Failed to update content")
        throw error
      }
    }
  }
  
  // Delete content
  export function deleteContentAction(contentId) {
    return async (dispatch) => {
      try {
        const response = await deleteContent(contentId)
        if (response?.data?.status === "success") {
          dispatch({
            type: CONFIRMED_DELETE_CONTENT,
            payload: { content_id: contentId },
          })
          handleSuccess("Content deleted successfully!")
          return { success: true, content_id: contentId }
        } else {
          throw new Error(response?.data?.message || "Failed to delete content")
        }
      } catch (error) {
        console.error("Delete content error:", error)
        dispatch({ type: "FAILED_DELETE_CONTENT", payload: error.message })
        showErrorAlert(error.message || "Failed to delete content")
        throw error
      }
    }
  }
  
  // Send content

  export function sendContentAction(sendType) {
    return async (dispatch) => {
      try {
        const response = await sendContent(sendType)
  
        if (response?.data?.status === "success") {
          dispatch({ type: CONFIRMED_SEND_CONTENT, payload: sendType })
          handleSuccess("Content sent successfully!")
          return { success: true, data: response.data.data }
        } else {
          dispatch({ type: FAILED_SEND_CONTENT, payload: response.data.message })
          showErrorAlert(response.data.message || "Failed to send content")
          return { success: false }
        }
      } catch (error) {
        console.error("Send content error:", error)
        dispatch({ type: FAILED_SEND_CONTENT, payload: error.message })
        showErrorAlert(error.message || "Failed to send content")
        return { success: false }
      }
    }
  }
  